import fetch$ from './fetchDocuments'
import addBackendEvents$ from './addBackendEvents'
import addPlayInEvents$ from './addPlayInEvents'
import addSlidesEvents$ from './addSlidesEvents'
import addUIEvents$ from './addUIEvents'
import setBookingInitialState$ from './setBookingInitialState'
import setPlayInInitialState$ from './setPlayInInitialState'
import setSlidesInitialState$ from './setSlidesInitialState'
import setQuestionsInitialState from './setQuestionsInitialState'
import setUIInitialState$ from './setUIInitialState'
import addBridgeDataEvents$ from './addBridgeDataEvents'
import setBridgeDataInitialState$ from './setBridgeDataInitialState'
import { combineEpics } from 'redux-observable'
import addSeatingOrderEvents$ from './addSeatingOrderEvents'

export default combineEpics(
  fetch$,
  addBackendEvents$,
  addPlayInEvents$,
  addSlidesEvents$,
  addUIEvents$,
  setBookingInitialState$,
  addBridgeDataEvents$,
  setBridgeDataInitialState$,
  setPlayInInitialState$,
  setSlidesInitialState$,
  setQuestionsInitialState,
  setUIInitialState$,
  addSeatingOrderEvents$
)
